import React, { Component } from "react";
import { useState } from "react";
import {
  FaBars,
  FaFacebook,
  FaStrava,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa";
// import {HiOutlineMail} from 'react-icons/hi'
// import {BsFillPersonLinesFill} from 'react-icons/bs'
import qhubhekaLogo from "../assests/qhubhekaLogo.PNG";
// import { Link } from 'react-scroll'

import WelcomePack from "../assests/QAC_WelcomePack.pdf";
import QAC_Constitution from "../assests/QAC_Constitution.pdf";

export default function Footer() {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <>
      <div className=" w-full h-[250px] flex justify-between items-center bg-red-700 text-white">
        <div className=" grid md:grid-cols-4 w-full bg-white text-[#001ea1] ">
          {/** Grid Item */}

          <div className=" col-span-2 group container  flex justify-center items-center bg-cover mx-auto ">
            {/**Hover effect */}

            <div>
              <a href="/">
                {" "}
                <img
                  src={qhubhekaLogo}
                  alt="Logo Image"
                  style={{ width: `230px` }}
                />
              </a>
            </div>
          </div>
          <div className=" pl-6 container  justify-center items-center mx-auto ">
            {/**Hover effect   text-[#001ea1] */}
            <div className="">
              <a>
                <button className=" font-bold  text-left items-left flex rounded-lg m-2">
                  {" "}
                  Navigate:
                </button>
              </a>
            </div>
            <div className="">
              <a href="/">
                <button className=" text-center items-center flex rounded-lg m-2 hover:font-weight:bold hover:scale-110 duration-200 hover:font-bold">
                  {" "}
                  Home
                </button>
              </a>
            </div>
            <div className="">
              <a href="/AboutUs">
                <button className="  text-center items-center flex rounded-lg m-2 hover:bold hover:scale-110 duration-200 hover:font-bold">
                  {" "}
                  About Us
                </button>
              </a>
            </div>
            <div className="">
              <a href="/MemberLogin">
                <button className="  text-center items-center flex rounded-lg m-2 hover:bold hover:scale-110 duration-200 hover:font-bold">
                  {" "}
                  Member Portal
                </button>
              </a>
            </div>
          </div>

          <div className="   ">
            {/**Hover effect */}
            <div className="">
              <a>
                <button className=" font-bold  text-left items-left flex rounded-lg m-2">
                  {" "}
                  Qhubeka Athletic Club is an
                </button>
              </a>
            </div>
            <div className="">
              <a>
                <button className=" font-bold  text-left items-left flex rounded-lg m-2">
                  {" "}
                  NPO with registration number
                </button>
              </a>
            </div>
            <div className="">
              <a>
                <button className=" font-bold  text-left items-left flex rounded-lg m-2">
                  {" "}
                  2023/705242/08
                </button>
              </a>
            </div>
            <div className=" text-left items-left">
              <a>
                <button className="  text-left items-left flex rounded-lg m-2 hover:bold hover:scale-110 duration-200 hover:font-bold">
                  {" "}
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#001ea1] text-white flex justify-between pt-5">
        <div>
          <p className="font-bold items-start justify-start flex">
            {" "}
            Qhubeka Athletic Club | Developed by GlobaTwist
          </p>
        </div>
        <div className="flex">
          <a
            className="w-10   text-white   "
            href="https://www.strava.com/clubs/786066/group_events/944626"
            target="_blank"
          >
            <FaStrava size={20} />
          </a>

          <a
            className="w-10   text-white "
            href="https://www.facebook.com/p/Qhubeka-AC-100075743505495/"
            target="_blank"
          >
            <FaFacebook size={20} />
          </a>

          <a
            className="w-10  text-white   "
            href="https://www.instagram.com/qhubeka_athletic_club/?locale=no&hl=en"
            target="_blank"
          >
            <FaInstagram size={20} />
          </a>

          <a
            className="w-10   text-white   "
            href="https://x.com/QhubekaAC"
            target="_blank"
          >
            <FaTiktok size={20} />
          </a>
        </div>
      </div>
    </>
  );
}
